import * as request from "../lib/lib";

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'GetInfo';

export const getMainNews = async () => {
    const response = await request.get(`${baseUrl}/Home`);

    return response;
};

export const getForeignersInfo = async () => {
    const response = await request.get(`${baseUrl}/News?categoryId=4`);

    return response;
};

//------ admin news -----------------

export const getAll = async () => {
    const result = await request.get(`${baseUrl}/News`);

    const data = Object.values(result);

    return data;
};


export const del = async (id) => {
    const result = await request.post(`${baseUrl}/News/${id}`);

    const data = Object.values(result);

    return data;
};

export const update = async (id, formData) => {
    const result = await request.put(`${baseUrl}/News/${id}`, formData);

    const data = Object.values(result);

    return data;
};

export const create = async (formData) => {
    const result = await request.post(`${baseUrl}/News`, formData);

    const data = Object.values(result);

    return data;
};

